import { RefObject, useCallback, useState } from 'react';

import { isTransparentBackground } from './isTransparentBackground';
import { readPopperPlacement } from './readPopperPlacement';
import { usePreventDatePickerBlurClose } from './usePreventDatePickerBlurClose';

const datePickerBackgroundVar = '--autoscript-datepicker-bg';

const syncPickerBackgroundFromInput = (wrapperRef: RefObject<HTMLElement | null>) => {
  const trigger = wrapperRef.current?.querySelector('input, button');
  if (!trigger) {
    return;
  }
  const { backgroundColor } = getComputedStyle(trigger);
  const value = isTransparentBackground(backgroundColor)
    ? 'var(--color-form-field-bg, var(--color-surface-muted))'
    : backgroundColor;
  document.documentElement.style.setProperty(datePickerBackgroundVar, value);
};

export const useDatePickerOpenState = (wrapperRef: RefObject<HTMLElement | null>) => {
  const [isOpen, setIsOpen] = useState(false);
  const [placement, setPlacement] = useState<'top' | 'bottom'>('bottom');

  const handleCalendarOpen = useCallback(() => {
    setIsOpen(true);
    syncPickerBackgroundFromInput(wrapperRef);
    requestAnimationFrame(() => {
      setPlacement(readPopperPlacement());
      syncPickerBackgroundFromInput(wrapperRef);
    });
  }, [wrapperRef]);

  const handleCalendarClose = useCallback(() => {
    setIsOpen(false);
    document.documentElement.style.removeProperty(datePickerBackgroundVar);
  }, []);

  usePreventDatePickerBlurClose(isOpen);

  return {
    isOpen,
    placement,
    handleCalendarOpen,
    handleCalendarClose,
  };
};
